export type JSAgentResponseDTO<T extends Record<string, unknown>> = {
    response: T
}

export type MessageDatagramPayloadUni = Record<string, string | number | Array<Record<string, unknown>>>

export type MessageDatagram<T = MessageDatagramPayloadUni> = {
    type: string
    payload: T
}

export type GetAIAssistHintDialogQueryArgs = {
    projectId: string
    omniUserId: string
    dialogId: string
    reqTypeCommand: string
    language: string
    nonActiveDialog: boolean
}

export enum MessageDatagramMode {
    GPT = "gpt",
    GET_REQUEST_TYPE = "get_request_types"
}

export interface MessageDatagramRoot {
    mode: MessageDatagramMode
}

export enum MessageSide {
    OPERATOR = "operator",
    CLIENT = "client"
}

export interface MessageDatagramPayload {
    side: MessageSide
    text: string
    timestamp: number
}

export interface MessageDatagramGpt extends MessageDatagramRoot {
    messages: MessageDatagramPayload[]
    operatorMessage: string
    dialog_id?: string
    omni_user_id: string
    reqTypeCommand: string
    request_type?: string
    language: string
    nonActiveDialog?: boolean
}

export interface MessageRequestTypesMode {
    mode: MessageDatagramMode
}
